import React from "react";
import Navbar from "./navbar";
import "./live-stream.css";

const LiveStream = () => {
  const videoUrl = process.env.REACT_APP_VIDEO_URL || "https://www.youtube.com/embed/m4hivxlyh64";
  const title = process.env.REACT_APP_LIVE_TITLE || "LIVE NOW";

  return (
    <section className="live-stream-section">
      <div className="home-content1">
        <Navbar />
        
        <h1 className="live-title">Richmond Live</h1>
        
        <div className="live-stream-content">
          
          <div className="live-stream-badge">{title}</div>
          
          <div className="live-stream-wrapper">
            <iframe
              width="100%"
              height="480"
              src={`${videoUrl}?autoplay=1&rel=0`}
              title="Live Stream"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveStream;
